<template>
  <div>
    <RadioGroup
      v-model="inValue"
      @on-change="onRadioBoxChange"
      vertical
    >
      <p class="iv-select-tree-check-list iv-fs-14 iv-fc-85 iv-m-b-8"
        v-for="(item, index) in list"
        :key="item.value || index" >
        <Radio :label="item.value || item.title">{{ selectUserSwitch ? item.fullTitle : item.title}}</Radio>
      </p>
    </RadioGroup>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default () {
        return []
      }
    },
    allList: {
      type: Array,
      default () {
        return []
      }
    },
    selectUserSwitch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inValue: this.value,
      copyList: this.list
    }
  },
  watch: {
    value (newVal) {
      this.inValue = newVal
    }
  },
  methods: {
    //单选框选择
    onRadioBoxChange (data) {
      this.copyList = Object.assign([], this.allList)
      this.copyList.map(item => {
        if (item.value == data) {
          this.$emit('on-radio-change', item)
        }
      })
    }
  }
}
</script>
